import { Flex, Text } from "@chakra-ui/layout";
import DataTable, { Cell } from "../components/table/ServerSideTable";
import { useAnnouncements } from "../hooks/announcements.hooks";
import { useMemo, useRef, useState } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { Announcement } from "../types/announcement.types";
import { useDisclosure } from "@chakra-ui/react";
import SimpleModal from "../components/modals/SimpleModal";
import PrimaryButton from "../components/PrimaryButton";
import { AddIcon } from "@chakra-ui/icons";
import AnnouncementForm, {
	AnnouncementFormHandler,
} from "../components/forms/AnnouncementForm";
import { useMutation, useQueryClient } from "react-query";
import {
	createAnnouncement,
	updateAnnouncement,
} from "../mutations/announcements.mutations";

const SettingsPageAnnouncementPanel = () => {
	const columns = useMemo<ColumnDef<Announcement>[]>(
		() => [
			{
				accessorFn: (row) => row.title,
				id: "title",
				header: "Titre",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
		],
		[],
	);
	const queryClient = useQueryClient();
	const disclosure = useDisclosure();
	const ref = useRef<AnnouncementFormHandler | null>(null);
	const handleClose = () => {
		disclosure.onClose();
		setAnnouncement(null);
	};
	const { mutate: mutateCreateAnnouncement } = useMutation({
		mutationFn: createAnnouncement,
		onSettled: () => {
			handleClose();
			queryClient.invalidateQueries("announcements");
		},
	});
	const { mutate: mutateUpdateAnnouncement } = useMutation({
		mutationFn: updateAnnouncement,
		onSettled: () => {
			handleClose();
			queryClient.invalidateQueries("announcements");
		},
	});
	const [announcement, setAnnouncement] = useState<Announcement | null>(null);

	return (
		<Flex direction="column">
			<Flex justify="space-between">
				<Text>Contenus</Text>
				<PrimaryButton w="fit-content" onClick={() => disclosure.onOpen()}>
					<AddIcon mr={4} />
					Ajouter une actualité
				</PrimaryButton>
			</Flex>
			<DataTable
				columns={columns}
				paginatedQuery={useAnnouncements}
				handleCellClick={(cell: Cell) => {
					setAnnouncement(cell.row);
					disclosure.onOpen();
				}}
				w={["auto"]}
				flexGrow={[1]}
			/>

			<SimpleModal
				title="Actualité"
				acceptText={announcement === null ? "Enregistrer" : "Ajouter"}
				isOpen={disclosure.isOpen}
				onClose={handleClose}
				onClick={async () => {
					if (ref.current === null) {
						return;
					}
					const valid = await ref.current.valid();
					if (valid === false) {
						return;
					}
					const values = ref.current.values();
					if (announcement === null) {
						mutateCreateAnnouncement(values);
					} else {
						mutateUpdateAnnouncement({
							id: announcement.id,
							...values,
						});
					}
				}}
			>
				<AnnouncementForm ref={ref} value={announcement ?? undefined} />
			</SimpleModal>
		</Flex>
	);
};

export default SettingsPageAnnouncementPanel;
